import { RootState } from '@src/redux/store'
import { prop } from 'ramda'
import { createSelector } from 'reselect'

import {
  ENROLLMENT,
  ENROLLMENT_ALL,
  ENROLLMENT_COURSES,
  ENROLLMENT_CREATE,
  ENROLLMENT_LIST,
  ENROLLMENT_STATUS,
  GLOBAL_STATE,
} from '../constants/actionTypes'

const enrollmentsSelector = (state: RootState) => prop(GLOBAL_STATE, state)

export const enrollmentSelector = createSelector(enrollmentsSelector, data => data[ENROLLMENT])

export const enrollmentCreateSelector = createSelector(enrollmentsSelector, data => data[ENROLLMENT_CREATE])

export const enrollmentListSelector = createSelector(enrollmentsSelector, data => data[ENROLLMENT_LIST])

export const enrollmentAllSelector = createSelector(enrollmentsSelector, data => data[ENROLLMENT_ALL])

export const enrollmentStatusSelector = createSelector(enrollmentsSelector, data => data[ENROLLMENT_STATUS])

export const enrollmentCoursesSelector = createSelector(enrollmentsSelector, data => data[ENROLLMENT_COURSES])
